import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import './NotFound.css'; // We'll create a simple CSS file for styling

const NotFound = () => {
  return (
    <div className="not-found-container">
      <Helmet>
        <title>404 - Page Not Found</title>
        <meta name="robots" content="noindex" />
      </Helmet>
      <h1>404</h1>
      <h2>Page Not Found</h2>
      <p>The page you are looking for might have been removed, had its name changed, or is temporarily unavailable.</p>
      <Link to="/" className="home-link">
        Go to Homepage
      </Link>
    </div>
  );
};

export default NotFound;
